import { isEqual } from 'lodash-es'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

import * as storage from '../../lib/storage'
import { TMapBounds, TMapZoomLevel } from '../schema'

type Center = {
  lat: number
  lng: number
}

type MapAction = {
  updateParams: (params: Partial<TMapParams>) => void
  updateCenter: (center: Center) => void
}

export type TMapParams = TMapBounds & {
  zoomLevel: TMapZoomLevel
}

type MapState = {
  params: TMapParams
  center: Center
  isSameParams: (params: Partial<TMapParams>) => boolean
  canFetchRoom: () => boolean
  actions: MapAction
}

export const ROOM_ZOOM_LEVEL = 13 // 1km

const initialParams = {
  zoomLevel: storage.getZoomLevel() ?? 10,
  swLat: 36.8590788,
  swLng: 126.352194,
  neLat: 38.2676238,
  neLng: 127.6046354,
}

const initialCenter = {
  lat: 37.566535,
  lng: 126.9779692,
}

export const useMapStore = create<MapState>()(
  subscribeWithSelector((set, get) => ({
    params: initialParams,
    center: initialCenter,
    canFetchRoom: () => {
      const {
        params: { zoomLevel },
      } = get()

      return zoomLevel >= ROOM_ZOOM_LEVEL
    },
    isSameParams: (params: Partial<TMapParams>) => {
      const { params: currentParams } = get()

      return isEqual(currentParams, params)
    },
    actions: {
      updateParams: (params: Partial<TMapParams>) => {
        set(state => ({
          params: { ...state.params, ...params },
        }))
      },
      updateCenter: center => {
        set(() => ({
          center,
        }))
      },
    },
  })),
)
